
<div [hidden]="showForm">
  <h4>
    Roles
  </h4>

  <button class="btn btn-primary"
          type="button"
          (click)="addNew()">
    Agregar
  </button>

  <hr />

  <app-generic-grid #grid
                    (rowToEdit)="edit($event)"
                    (rowToDelete)="delete($event)">
  </app-generic-grid>

</div>
<!-- grid container -->

<div [hidden]="!showForm">

  <div class="row">
    <div class="col-md-6 col-sm-12 mx-auto">

      <h5>Agregar Rol</h5>

      <hr />
      <br />

      <form [formGroup]="rolForm">

        <igx-input-group>
          <input igxInput name="Code"
                 [igxFocus]="showForm"
                 [readOnly]="isEdition"
                 [ngClass]="{'is-invalid': rolForm.get('Code').errors && rolForm.get('Code').touched}"
                 type="text"
                 aria-label="Código"
                 formControlName="Code" />
          <label igxLabel for="Code">Código</label>
        </igx-input-group>

        <igx-input-group>
          <input igxInput name="Name"
                 [igxFocus]="showForm && isEdition"
                 [ngClass]="{'is-invalid': rolForm.get('Name').errors && rolForm.get('Name').touched}"
                 type="text"
                 aria-label="Nombre"
                 formControlName="Name" />
          <label igxLabel for="Name">Nombre</label>
        </igx-input-group>

        <br />
        <hr />

        <div class="d-flex justify-content-between">
          <button class="btn btn-primary"
                  *ngIf="!isEdition"
                  type="submit"
                  [disabled]="!isValidForm()"
                  (click)="save()">
            Guardar
          </button>
          <button class="btn btn-primary"
                  *ngIf="isEdition"
                  type="submit"
                  [disabled]="!isValidForm()"
                  (click)="update()">
            Guardar cambios
          </button>

          <button class="btn btn-secondary"
                  type="button"
                  (click)="cancel()">
            Cancelar
          </button>
        </div>

      </form>

    </div>
  </div>

</div>
<!-- form container -->
